module.exports = __webpack_public_path__ + "static/media/siddharth-big-banyan-tree-trip-banner.d664abee.jpg";